module.exports = __webpack_public_path__ + "static/media/circle-check-gray.fe0e3aba.svg";